import React from "react";
import { ArrowRight } from "@phosphor-icons/react";
import { KpiCard, Money, Delta, Segmented, Pipeline, SalesCard, CollectionsCard, MachineCard } from "./HomeParts";

const RANGES = [{ value: "today", label: "Today" }, { value: "week", label: "Week" }, { value: "this_month", label: "Month" }];
const RECEIVED_LABEL = { today: "Received today", week: "Received this week", this_month: "Received this month" };
const VS = { today: "yesterday", week: "last week", this_month: "last month" };

function greeting() {
  const h = Number(new Date().toLocaleString("en-US", { hour: "numeric", hour12: false, timeZone: "Asia/Kolkata" }));
  return h < 12 ? "Good morning" : h < 17 ? "Good afternoon" : "Good evening";
}

export default function HomeDashboard({ user, overview, today, revenueTimeline, revenueTimelineWeek, receivedRange, setReceivedRange,
  receivedData, onStageClick, onOpenOrder, onSalesBucketClick, onReceivablesClick, onReceivedClick }) {
  const restricted = user?.role === "secondary_admin" || user?.role === "accountant";
  const isSec = user?.role === "secondary_admin";
  const first = (user?.name || "").split(/\s+/)[0] || "";
  const date = new Date().toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long", timeZone: "Asia/Kolkata" });
  const range = RANGES.some((r) => r.value === receivedRange) ? receivedRange : "today";
  return (
    <div className="space-y-6" data-testid="home-dashboard">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-3xl font-semibold text-slate-50 tracking-tight" data-testid="home-greeting">{greeting()}{first ? `, ${first}` : ""}</h1>
          <p className="mt-1 text-slate-400">{date} · {today?.total_today ?? 0} orders came in today</p>
        </div>
        <Segmented options={RANGES} value={range} onChange={setReceivedRange} testid="home-range" />
      </div>

      <div className={`grid grid-cols-1 sm:grid-cols-2 ${restricted ? "lg:grid-cols-3" : "lg:grid-cols-4"} gap-4`}>
        {!restricted && (
          <KpiCard label="Total receivable" testid="hero-receivable" onClick={onReceivablesClick}
            foot={<span>From {overview?.receivable_from_parties ?? 0} customers{overview?.total_advance_held > 0 && <> · <span className="text-emerald-600" data-testid="home-advance-held">Advance ₹{Math.round(overview.total_advance_held).toLocaleString("en-IN")}</span></>} <ArrowRight size={12} className="inline" /></span>}>
            <Money value={overview?.total_receivable} />
          </KpiCard>
        )}
        <KpiCard label={RECEIVED_LABEL[range]} testid="hero-received" onClick={onReceivedClick}
          foot={<Delta pct={receivedData?.delta_pct} vs={VS[range]} />}>
          <Money value={receivedData?.received} />
        </KpiCard>
        <KpiCard label="Orders today" testid="kpi-orders-today" foot={`${today?.completed_today ?? 0} completed today`}>
          {(today?.total_today ?? 0).toLocaleString("en-IN")}
        </KpiCard>
        <KpiCard label="Customers" testid="kpi-customers" foot={`${(overview?.total_orders ?? 0).toLocaleString("en-IN")} orders all time`}>
          {(overview?.total_customers ?? 0).toLocaleString("en-IN")}
        </KpiCard>
      </div>

      <Pipeline counts={overview?.counts_by_status} onStageClick={onStageClick} />

      <div className="grid xl:grid-cols-[1fr_400px] gap-4 items-start">
        {isSec ? (
          <SalesCard title="Sales last 7 days" timelines={revenueTimelineWeek} onBucketClick={onSalesBucketClick} />
        ) : !restricted ? (
          <SalesCard title="Sales this month" timelines={revenueTimeline} onBucketClick={onSalesBucketClick} />
        ) : <div className="hidden xl:block" />}
        <div className="space-y-4 min-w-0">
          <CollectionsCard today={today} />
          <MachineCard today={today} onOpenOrder={onOpenOrder} />
        </div>
      </div>
    </div>
  );
}
